import { all, createLowlight } from "lowlight"

// TipTap's CodeBlockLowlight has no exclude list; lowlight has no unregister.
// Omit grammars here so they never appear in listLanguages() (the picker).
const grammars = { ...all }
delete grammars.brainfuck

export const lowlight = createLowlight(grammars)
